import ESigningFormFiles from '../ESigningForm.files';

/**
 * Step-1 logic for the Default form variant.
 * Uses ESigningFormBase via composition for shared utilities.
 */
export default class ESigningFormDefault {
    constructor(base) {
        this.base = base;
        this.validation = base.validation;
        this.base.submitEndpoint = '/api/e-signing/v2/initiate-signing';
        this.initStep1EventListeners();
        ESigningFormFiles.updateDropZoneState();
    }

    /**
     * @description Initialize step 1 event listeners (file upload, agreement number, step 1 next button)
     * Call this again after the partial view is reloaded via AJAX.
     * @returns void
     */
    initStep1EventListeners() {
        const documentFileInput = document.getElementById('documentFile');
        const documentDropZone = document.getElementById('documentDropZone');

        // Drag-and-drop upload area
        if (documentDropZone && documentFileInput) {
            documentDropZone.addEventListener('click', (evt) => {
                evt.preventDefault();
                documentFileInput.click();
            });

            documentDropZone.addEventListener('keydown', (evt) => {
                if (evt.key !== 'Enter' && evt.key !== ' ') return;
                evt.preventDefault();
                documentFileInput.click();
            });

            ['dragenter', 'dragover'].forEach((eventName) => {
                documentDropZone.addEventListener(eventName, (evt) => {
                    evt.preventDefault();
                    evt.stopPropagation();
                    documentDropZone.classList.add('is-dragover');
                });
            });

            ['dragleave', 'dragend'].forEach((eventName) => {
                documentDropZone.addEventListener(eventName, (evt) => {
                    evt.preventDefault();
                    evt.stopPropagation();
                    documentDropZone.classList.remove('is-dragover');
                });
            });

            documentDropZone.addEventListener('drop', (evt) => {
                evt.preventDefault();
                evt.stopPropagation();
                documentDropZone.classList.remove('is-dragover');

                const droppedFiles = Array.from(evt.dataTransfer?.files || []);
                if (!droppedFiles.length) return;

                const pdfFiles = droppedFiles.filter(
                    (file) => file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
                );
                if (!pdfFiles.length) return;

                const dataTransfer = new DataTransfer();
                dataTransfer.items.add(pdfFiles[0]);
                documentFileInput.files = dataTransfer.files;
                ESigningFormFiles.handleFileChange(this, { target: documentFileInput });
                this.updateStep1NextButtonState();
            });
        }

        if (documentFileInput) {
            documentFileInput.addEventListener('change', (e) => {
                ESigningFormFiles.handleFileChange(this, e);
                this.updateStep1NextButtonState();
            });
        }

        const agreementNumberInput = document.getElementById('AgreementNumber');
        if (agreementNumberInput) {
            agreementNumberInput.addEventListener('input', () => this.updateStep1NextButtonState());
            agreementNumberInput.addEventListener('change', () => this.updateStep1NextButtonState());
            agreementNumberInput.addEventListener('blur', () => this.updateStep1NextButtonState());
        }

        const step1NextBtn = document.querySelector('#Step1Next');
        if (step1NextBtn) {
            step1NextBtn.addEventListener('click', this.handleStep1Next);
        }
    }

    handleStep1Next = () => {
        if (this.validation.validateStep1()) {
            this.base.showStep(2);
        }
    };

    updateStep1NextButtonState() {
        const nextButton = document.getElementById('Step1Next');
        const signingTemplateInput = document.getElementById('signingTemplate');
        const documentFileInput = document.getElementById('documentFile');
        const agreementNumberInput = document.getElementById('AgreementNumber');

        if (!nextButton || !signingTemplateInput || !documentFileInput || !agreementNumberInput) return;

        const hasTemplate = signingTemplateInput.value?.trim() !== '';
        this.base.toggleStep1NextVisibility(hasTemplate);
        const files = Array.from(documentFileInput.files || []);
        const hasValidPdfFiles = files.length > 0 && files.every((file) => file.type === 'application/pdf');
        const hasAgreementNumber = agreementNumberInput.value?.trim() !== '';

        if (hasTemplate && hasValidPdfFiles && hasAgreementNumber) {
            nextButton.classList.remove('disabled');
        } else {
            nextButton.classList.add('disabled');
        }
    }
}
